(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["summer1-Review-Slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
    $('.revslick').show().slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots:true
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
    $('.revslick_v2').show().slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots:true
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
